import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import { FormattedHTMLMessage } from 'react-intl';
import cn from 'classnames';

import { appSizeType, headerVisible as headerVisibleType, appLocaleType } from 'app/pages/app/app.types';
import paths from 'config/paths';
import appHelper from 'app/pages/app/app.helper';

import currentUserType from 'app/components/current-user/current-user.types';

// import Subheader from 'app/components/subheader';

import Logo from 'app/ui/logo';
import Dropdown from 'app/ui/dropdown';
import RateTopGamesBadge from 'app/ui/header/components/rate-top-games-badge/rate-top-games-badge';
import Avatar from 'app/ui/avatar';

import locationShape from 'tools/prop-types/location-shape';

import HeaderMenu from './components/header-menu';
import AddContentMenu from './components/add-content-menu';
import GuestSessionLinks from './components/header-menu/components/guest-session-links';
import MyLibraryMenu from './components/my-library-menu';
import Search from './components/search';
import Notifications from './components/notifications';

import './header.styl';

export const headerPropTypes = {
  currentUser: currentUserType,
  size: appSizeType.isRequired,
  locale: appLocaleType.isRequired,
  headerVisible: headerVisibleType,
  router: PropTypes.shape({
    location: locationShape,
  }),
  needsSubheader: PropTypes.bool,
  className: PropTypes.string,
};

const defaultProps = {
  currentUser: {},
  router: null,
  headerVisible: false,
  needsSubheader: false,
  className: '',
};

@connect((state) => ({
  size: state.app.size,
  locale: state.app.locale,
  headerVisible: state.app.headerVisible,
  currentUser: state.currentUser,
  currentUserId: state.currentUser.id,
  currentUserSlug: state.currentUser.slug,
}))
@withRouter
export default class Header extends React.Component {
  static propTypes = headerPropTypes;

  static defaultProps = defaultProps;

  constructor(props) {
    super(props);

    this.gamesRef = React.createRef();
    this.subHeaderRef = React.createRef();
  }

  componentDidMount() {
    this.setSubheaderPointer();
    window.addEventListener('resize', this.setSubheaderPointer);
  }

  componentDidUpdate(previousProperties) {
    const { size } = this.props;
    const curPathname = this.props.router.location.pathname;
    const previousPathname = previousProperties.router.location.pathname;

    if (
      previousPathname !== curPathname &&
      this.hasSubheader() &&
      this.gamesRef.current &&
      appHelper.isDesktopSize({ size })
    ) {
      this.setSubheaderPointer();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setSubheaderPointer);
  }

  setSubheaderPointer = () => {
    if (this.subHeaderRef.current) {
      this.subHeaderRef.current.calcPointer(this.gamesRef.current);
    }
  };

  hasSubheader() {
    const { needsSubheader } = this.props;

    return needsSubheader;
  }

  renderSubheader() {
    // const { pathname } = this.props.router.location;
    // const subHeaderItems = headerHelper.getSubHeaderItems({
    //   pathname,
    //   needsSuggestions: config.features.suggestions,
    // });

    return (
      <div className="header__subheader">{/* <Subheader ref={this.subHeaderRef} items={subHeaderItems} /> */}</div>
    );
  }

  renderDesktop() {
    const { currentUser, headerVisible, className } = this.props;
    const currentUserId = currentUser.id || '';
    const headerClass = cn('header', {
      header_hidden: !headerVisible,
      'header_with-subheader': this.hasSubheader(),
      [className]: !!className,
    });

    return (
      <header className={headerClass}>
        <div className="header__wrapper">
          <div className="header__item">{this.renderLogo()}</div>
          {!currentUserId && (
            <div className="header__item">
              <ul>
                <li className="header__item-badge">
                  <RateTopGamesBadge isTag forceShow />
                </li>
              </ul>
            </div>
          )}
          <div className="header__item header__item_search">
            <div className="header__item header__item_center header__search">
              <Search />
            </div>
          </div>
          <div className="header__item">
            {currentUserId ? (
              <>
                {this.renderMyLibrary()}
                <Notifications />
                {this.renderAdd()}
              </>
            ) : (
              <GuestSessionLinks className="header__item-link" />
            )}
            {this.props.locale === 'en' && (
              <Link className="header__item-link" to={paths.apidocs} href={paths.apidocs} rel="nofollow">
                <FormattedHTMLMessage id="shared.social_menu_apidocs" />
              </Link>
            )}
            <HeaderMenu />
          </div>
        </div>
        {this.hasSubheader() && this.renderSubheader()}
      </header>
    );
  }

  renderPhone() {
    const { className } = this.props;

    const headerClass = cn('header', {
      [className]: !!className,
    });

    return (
      <header className={headerClass}>
        <div className="header__item">{this.renderLogo()}</div>
        <div className="header__item header__search">
          <Search />
        </div>
        <div className="header__item">
          <div className="header__menu-wrapper">
            <HeaderMenu />
          </div>
        </div>
      </header>
    );
  }

  renderLogo = () => (
    <Link className="header__item-link header-logo" to={paths.index}>
      <Logo locale={this.props.locale} />
    </Link>
  );

  renderMyLibrary = () => {
    const { currentUser } = this.props;

    const renderedButton = (
      <Link className="header__item-link header__library-link" to={paths.profileGames(currentUser.slug || '')}>
        <FormattedHTMLMessage id="shared.header_my_library" />
      </Link>
    );

    return (
      <div className="header__my-library">
        <Link className="header__avatar-link" to={paths.profileGames(currentUser.slug || '')}>
          <Avatar size={36} className="header__user-avatar" src={currentUser.avatar} profile={currentUser} />
        </Link>
        <div className="header__my-library-dropdown">
          <Dropdown
            isMouseOver
            closeOnClick
            renderedButton={renderedButton}
            renderedContent={<MyLibraryMenu />}
            containerClassName="header-dropdown-menu__my-library-dropdown-container"
          />
        </div>
      </div>
    );
  };

  renderAdd() {
    return (
      <div className="header__add-dropdown">
        <Dropdown
          isMouseOver
          renderButton={this.renderButtonAdd}
          renderContent={() => <AddContentMenu locale={this.props.locale} />}
          containerClassName="header__dropdown-menu__dropdown-container"
          kind="menu"
        />
      </div>
    );
  }

  renderButtonAdd = () => <div className={cn('header__add-game-icon')} />;

  render() {
    const { size } = this.props;

    return appHelper.isDesktopSize(size) ? this.renderDesktop() : this.renderPhone();
  }
}
